import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAll,
  ItemStatus,
} from "../../../../features/admin/master/state/Slice";
import { getAllCountries } from "../../../../features/admin/common/Slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  
    const [modalShow, setModalShow] = React.useState(false);
    const [modalMessage, setModalMessage] = useState("");
  const countries = useSelector((state) => state.common.all_country);
  const state = useSelector((state) => state.masters.state);

  const [name, setName] = useState("");
  const [country, setCountry] = useState("");

  useEffect(() => {
    dispatch(getAllCountries());  // Load all countries when the component mounts
  }, [dispatch]);

  useEffect(() => {
    fetch();
  }, [name, country]);

  const fetch = async (page = state?.current_page) => {
     await dispatch(getAllCountries());
    await dispatch(
      GetAll({
        name: name,
        country_id: country?.value || "",
        page: page,
        per_page: state?.per_page,
      })
    );
  };


  const deleteData = async (id) => {
    try {
      await dispatch(Delete(id));
       setModalMessage("Deleted Successfully");
      setModalShow(true);
      await fetch();
      return true; // Success
    } catch (error) {
      setModalMessage("Delete Failed");
      setModalShow(true);
      console.error(error);
      return false; // Error
    }
  };

  const toggleStatus = async (id) => {
    try {
      await dispatch(ItemStatus(id));
      await fetch();
      return true; // Success
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  return {
    state,
    name,
    setName,
    country,
    setCountry,
    fetch,
    deleteData,
    toggleStatus,
     modalMessage,
    modalShow,
    setModalShow,
  };
};
